import React from 'react';
import { ButtonPillView } from '../Buttons/ButtonPillView';
import { THandleButtonClick } from './utils/types';
import styles from './Calculator.module.css';

type TCalculatorSubmitButtonProps = {
    isEnabled: boolean;
    label: string;
    handleClick: THandleButtonClick;
    parentStyleNames?: string[];
};
const CalculatorSubmitButton = React.memo(({ isEnabled, label, handleClick, parentStyleNames }: TCalculatorSubmitButtonProps) => {
    return (
        <div className={styles.calculatorButtonStyled}>
            <ButtonPillView
                styleName="calculatorSubmitButton"
                parentStyleNames={parentStyleNames}
                hierarchy="primary"
                position="floating"
                size={'large'}
                label={label ?? ''}
                onClick={handleClick}
                isDisabled={!isEnabled}
                maxWidth="100%"
            />
        </div>
    );
});
export { CalculatorSubmitButton };
